import CheckboxGroup from './CheckboxGroup';

// export types
export type { CheckboxGroupProps } from './CheckboxGroup';
export type { CheckboxGroupContextValue } from './CheckboxGroupContext';

// export components
export { CheckboxGroupContext } from './CheckboxGroupContext';
export { CheckboxGroup };
export default CheckboxGroup;
